import SettingFrame from "../../../../components/@settings/SettingFrame";
import UpdateTaxRate from "../../../../components/@tax/UpdateTaxRate";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function TaxRateUpdatePage() {

    let routeType = routeTypes.admin

    return (
        <SettingFrame
            routeType={routeType}
        >
            <UpdateTaxRate
                routeType={routeType}
            />
        </SettingFrame>
    )
}       